export enum ReadyState {
  HaveNothing = 0,
  HaveMetadata = 1,
  HaveCurrentData = 2,
  HaveFutureData = 3,
  HaveEnoughData = 4,
}
